import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86b8410e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  align: "center",
  class: "mt-4"
}
const _hoisted_2 = {
  align: "end",
  class: "mb-5"
}
const _hoisted_3 = {
  key: 0,
  align: "center"
}
const _hoisted_4 = {
  key: 1,
  align: "center"
}
const _hoisted_5 = {
  key: 0,
  align: "center"
}
const _hoisted_6 = {
  key: 1,
  align: "center"
}

import { useI18n } from "vue-i18n"
import { ref, onMounted, computed, Ref, onUnmounted } from "vue"
import { RequestResponse } from "@/types"
import InviteDoctor from "./InviteDoctor.vue"
import { hospitalActions } from "@/stores/hospital-actions"

import router from "@/router"
import {
  departmentValueToDeMap,
  departmentValueToEnMap,
} from "@/types/hospital-spec"
interface DoctorInvites {
  doctorId: string
  firstName: string
  lastName: string
  inviteEmail: string
  photo: string
  department: string
}
interface invitation {
  _id: string
  inviteEmail: string
  photo: string
  department: string
}
interface HospitalDoctor {
  _id: string
  firstName: string
  lastName: string
  email: string
  photo: string
  department: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalDoctors',
  setup(__props) {

const hospitalDoctors = ref<HospitalDoctor[]>([])
const invitedDoctors = ref<invitation[]>([])
const loading = ref(false)
const { t } = useI18n()
const hospitalAction = hospitalActions()
const page = ref(1)
const itemsPerPage = ref(5)
const requestResponse = ref<RequestResponse>()
const inviteDoctorDialog = ref(false)
const tab = ref<string>("doctors")
const headers = computed(() => {
  return [
    {
      key: "photo",
      sortable: false,
      align: "center",
    },
    { title: t("table.name"), key: "name", sortable: false, align: "center" },

    {
      title: t("table.department"),
      key: "department",
      sortable: false,
      align: "center",
    },
    { title: t("email"), key: "email", sortable: false, align: "center" },
    {
      title: t("table.action"),
      key: "action",
      sortable: false,
      align: "center",
    },
  ]
})
const invitationHeader = computed(() => {
  return [
    {
      key: "photo",
      sortable: false,
      align: "center",
    },
    {
      title: t("table.department"),
      key: "department",
      sortable: false,
      align: "center",
    },
    { title: t("email"), key: "inviteEmail", sortable: false, align: "center" },
    {
      title: t("table.action"),
      key: "action",
      sortable: false,
      align: "center",
    },
  ]
})

onMounted(() => {
  loadDoctors()
  loadInvites()
  window.addEventListener("locale-changed", loadDoctors)
})
onUnmounted(() => {
  window.removeEventListener("locale-changed", loadDoctors)
})

const takeBack = async (id: string) => {
  loading.value = true

  const response = await hospitalAction.takeBackInvite({ inviteId: id })

  requestResponse.value = response

  if (response.success) {
    loadInvites()
  }
  loading.value = false
}

const loadDoctors = async () => {
  inviteDoctorDialog.value = false
  loading.value = true

  const response = await hospitalAction.getAllDoctors()

  requestResponse.value = response

  if (response.success) {
    hospitalDoctors.value = response.result as HospitalDoctor[]
  }

  loading.value = false
}

const handleRowClick = (click: any, doctor: any) => {
  router.push({
    path: `doctor/${doctor.item.doctorId}`,
  })
}

const doctorDepartment = (value: string): string => {
  return localStorage.getItem("locale") == "de"
    ? departmentValueToDeMap[value as string]
    : departmentValueToEnMap[value as string]
}

const loadInvites = async () => {
  inviteDoctorDialog.value = false
  loading.value = true

  const response = await hospitalAction.getDoctors("notAccepted")

  requestResponse.value = response

  if (response.success) {
    invitedDoctors.value = response.result as invitation[]
  }
  loading.value = false
}

const doctorArray = computed((): DoctorInvites[] => {
  const array: any[] = []

  hospitalDoctors.value.forEach((doctor) => {
    const firstName = doctor?.firstName ?? ""
    const lastName = doctor?.lastName ?? ""
    const singleDoctor = {
      doctorId: doctor._id,
      photo: doctor?.photo,
      name: firstName + " " + lastName,
      department: doctorDepartment(doctor.department),
      email: doctor.email,
    }
    array.push(singleDoctor)
  })

  return array
})

const doctorInvitesArray = computed((): any[] => {
  const array: invitation[] = []

  invitedDoctors.value.forEach((invite) => {
    const singleDoctor = {
      _id: invite._id,
      photo: invite?.photo,
      department: invite.department,
      inviteEmail: invite.inviteEmail,
    }
    array.push(singleDoctor)
  })

  return array
})

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("hospital.your-doctors")), 1)
    ]),
    _createVNode(_component_v_divider, { class: "mt-3" }),
    _createVNode(InviteDoctor, {
      modelValue: inviteDoctorDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inviteDoctorDialog).value = $event)),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (inviteDoctorDialog.value = false)),
      onInvited: loadInvites
    }, null, 8, ["modelValue"]),
    (!loading.value)
      ? (_openBlock(), _createBlock(_component_request_status, {
          key: 0,
          response: requestResponse.value
        }, null, 8, ["response"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        color: "#3fb984",
        class: "mr-10 mt-5",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (inviteDoctorDialog.value = true))
      }, {
        append: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: "mdi-plus",
            size: "x-large"
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("hospital.add-doctor")), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_tabs, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tab).value = $event)),
      "show-arrows": "",
      "bg-color": "#25344d",
      grow: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "doctors" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("hospital.doctors")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "invites" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("hospital.invitations")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "doctors" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              style: {"margin-top":"9px","cursor":"pointer"},
              "items-per-page": itemsPerPage.value,
              "onUpdate:itemsPerPage": _cache[4] || (_cache[4] = ($event: any) => ((itemsPerPage).value = $event)),
              headers: headers.value,
              loading: loading.value,
              items: doctorArray.value,
              "onClick:row": handleRowClick
            }, {
              [`item.photo`]: _withCtx((props) => [
                (props.item.photo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_v_img, _mergeProps({
                        src: props.item.photo,
                        alt: "student Image"
                      }, props, {
                        class: "image mb-2",
                        referrerpolicy: "no-referrer",
                        rel: "noreferrer"
                      }), null, 16, ["src"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_v_img, _mergeProps(props, {
                        src: require('../../../../assets/doctor1.png'),
                        alt: "student Image",
                        class: "image mb-2",
                        referrerpolicy: "no-referrer",
                        rel: "noreferrer"
                      }), null, 16, ["src"])
                    ]))
              ]),
              _: 2
            }, 1032, ["items-per-page", "headers", "loading", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "invites" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              style: {"margin-top":"9px"},
              "items-per-page": itemsPerPage.value,
              "onUpdate:itemsPerPage": _cache[5] || (_cache[5] = ($event: any) => ((itemsPerPage).value = $event)),
              headers: invitationHeader.value,
              loading: loading.value,
              items: doctorInvitesArray.value
            }, {
              [`item.photo`]: _withCtx((props) => [
                (props.item.photo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_v_img, _mergeProps({
                        src: props.item.photo,
                        alt: "student Image"
                      }, props, {
                        class: "image mb-2",
                        referrerpolicy: "no-referrer",
                        rel: "noreferrer"
                      }), null, 16, ["src"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_v_img, _mergeProps(props, {
                        src: require('../../../../assets/doctor1.png'),
                        alt: "student Image",
                        class: "image mb-2",
                        referrerpolicy: "no-referrer",
                        rel: "noreferrer"
                      }), null, 16, ["src"])
                    ]))
              ]),
              [`item.action`]: _withCtx((props) => [
                _createVNode(_component_v_btn, {
                  size: "large",
                  class: "mt-2",
                  density: "compact",
                  color: "red",
                  icon: "mdi-trash-can-outline",
                  onClick: ($event: any) => (takeBack(props.item._id))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["items-per-page", "headers", "loading", "items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})